import React, { useState, useEffect } from 'react';
import { store } from '../../app/store';
import { postAPI } from '../../app/api';
import Sidebar from '../Universal/Sidebar';
import Header from '../Universal/Header';
import { useParams } from 'react-router-dom';
import { hasPermission, isAdmin } from '../../store/hooks/Permission';

export default function ExamResult() {
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const { exam_id, user_unique_id } = useParams();
  const store_data = JSON.parse(store());
  const [ExamData, setExamData] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [canView, setCanView] = useState(false);

  const fetchExamData = async () => {
    const filter = { org_id: store_data?.org_id, user_unique_id: user_unique_id, exam_id: exam_id }
    const response = await postAPI("/results/enroll-list", filter);
    if (response?.status) {
      setExamData(response?.data)
      setLoading(false)
    } else {
      setExamData([])
      setLoading(false)
    }
  }

  useEffect(() => {
    const checkPermissions = async () => {
      if (isAdmin()) {
        setCanView(true);
        fetchExamData();
      } else {
        const viewAllowed = await hasPermission("EXAM", "Results", "VIEW");
        setCanView(viewAllowed);
        if (viewAllowed) {
          fetchExamData();
        } else {
          setLoading(false);
        }
      }
    };
    checkPermissions();
  }, [])
  return (
    <>
      {!canView ? (
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="alert alert-danger">
            You do not have permission to view this page.
          </div>
        </div>
      ) : (
        <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
              Back
            </button>
            <p className='text-right mb-0'><small className="fw-bold py-3">Dashboard<span className="text-muted fw-light"> / Result Details</span> </small></p>
          </div>

          <div class="container-xxl flex-grow-1 container-p-y">
            <div class="row">
              {
                ExamData && ExamData.length > 0 ?
                  ExamData?.map((val, index) => (
                    <div class="col-md-6 col-xl-4 order-2 order-lg-1 mt-2">
                      <div class="card" >
                        <div class="card-body text-center">
                          <h5>{val?.qusetion}</h5>
                          <p className='mt-1'>My Answer: {val?.is_mcq ? val?.answer : val[val?.exam_answer] || 0}</p>
                        </div>
                        {/* <div class="card-footer text-center">
                          <button class="btn btn-primary waves-effect waves-light" type="button" onClick={() => {window.location.href = `/Exams/${val?.id}`}}>Start Test</button>
                        </div> */}
                      </div>
                    </div>
                  ))
                  : ''
              }
            </div>
          </div>
        </div>
        </div>
      )}
    </>
  )
}
